module.exports = __webpack_public_path__ + "static/media/29ADMSPC18.dc0ebf4b.jpg";